// extracted by mini-css-extract-plugin
export var sliderRange = "_le-2";
export var sliderRoot = "_le-0";
export var sliderThumb = "_le-3";
export var sliderTrack = "_le-1";